import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';

import { faEllipsisV } from '@awesome.me/kit-bde9a98016/icons/sharp/solid';

import { AhsTranslationService } from '@nx-ahs/base-translate';

import { LanguageService } from '../../../../core/services/language.service';
import { SecurityService } from '../../../../core/services/security.service';
import { UserModel } from '../../../../shared/models/user/user';
import { AppCoreService } from '../../../../core/services/app-core.service';
import { HelpService } from '../../../../core/services/help.service';
import { IntroConfig } from '../../../../shared/models/portal/introConfig';

@Component({
	selector: 'ahs-intro',
	templateUrl: './intro.component.html',
	styleUrls: ['./intro.component.scss'],
	standalone: false
})
export class IntroComponent implements OnInit {
	public faEllipsisV = faEllipsisV;
	public showIntro = false;
	public introConfig: IntroConfig = null;
	public user: UserModel;

	@ViewChild('skipit', { static: false }) skipit: ElementRef;

	constructor(
		private ahsTranslationService: AhsTranslationService,
		private languageService: LanguageService,
		private appCoreService: AppCoreService,
		private helpService: HelpService,
		private securityService: SecurityService
	) {}

	ngOnInit() {
		this.getLanguage().then(() => {
			this.helpService.showIntro.subscribe((val) => {
				if (val) {
					setTimeout(() => {
						this.skipit?.nativeElement?.focus();
					}, 0);
					this.getLanguage().then();
				}
				this.showIntro = val;
			});
		});
		this.ahsTranslationService.onLangChange.subscribe((data) => this.getLanguage());
	}

	private async getLanguage(): Promise<void> {
		// get translations from client config
		const configLanguages = [];
		this.appCoreService.clientConfig.languages?.forEach((l) => {
			configLanguages.push(l.pages.tutorial);
		});
		const languages = await this.languageService.getLanguagesForPublicPage('intro').toPromise();
		this.ahsTranslationService.loadTranslations(...languages.locales);

		this.loadIntroItems();
	}
	public welcomeImageSrc: string;

	// TODO - Move the config object outside of the language array now that the translations are handled in the DB
	private loadIntroItems(): void {
		// get the intro items based on the langauge
		this.appCoreService.clientConfig.languages?.forEach((l, i) => {
			if (this.appCoreService.clientConfig.languages[i].code === 'en') {
				this.welcomeImageSrc = this.appCoreService.clientConfig.languages[i].pages.intro.data.IMG;
				this.introConfig = this.appCoreService.clientConfig?.languages[i]?.pages?.intro?.data;
				this.introConfig.introItems = (this.introConfig.introItems as any[]).filter((i) => {
					if (i.showCondition) {
						let val;
						this.user = this.securityService.getCurrentUser();
						if (this.user) val = this.user[i.showCondition] == true;
						return val;
					} else return true;
				});
			}
		});
	}

	public hideIntro() {
		this.helpService.showIntro.next(false);
		this.helpService.showTutorial.next(true);
	}

	@ViewChild('slides') slides: ElementRef | undefined;

	next() {
		this.slides?.nativeElement.swiper.slideNext();
	}

	prev() {
		this.slides?.nativeElement.swiper.slidePrev();
	}
}
